import { Series } from 'remotion';
import {
  HouseWarmingDetails,
  houseWarmingDurations,
  HouseWarmingInviters,
  HouseWarmingPhoto,
  HouseWarmingTitle,
  HouseWarmingWelcome
} from './HouseWarmingComponents';

interface Props {
  props: any;
  labels: any;
  color: string;
  image?: any;
  className?: string;
}

const HouseWarmingTemplate = (prop: Props) => {
  const { props, labels, color, image = null, className = '' } = prop;
  return (
    <Series>
      <Series.Sequence durationInFrames={houseWarmingDurations[0]}>
        <HouseWarmingWelcome image={image} props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={houseWarmingDurations[1]}>
        <HouseWarmingTitle props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={houseWarmingDurations[2]}>
        <HouseWarmingPhoto props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={houseWarmingDurations[3]}>
        <HouseWarmingDetails props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={houseWarmingDurations[4]}>
        <HouseWarmingInviters props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
    </Series>
  );
};

export default HouseWarmingTemplate;
